<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card :title="title">
          <v-form @submit.prevent="handleSubmit">
            <v-container class="py-0">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="chemicals"
                    name="chemical"
                    label="Chemical"
                    v-model="resource.chemical"
                    item-text="name"
                    item-value="id"
                    hide-details
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    type="number"
                    autocomplete="off"
                    data-lpignore="true"
                    :disabled="isReadOnly"
                    v-model="resource.cost"
                    name="cost"
                    label="Cost"
                  />
                </v-col>
              </v-row>
              <v-row>
                <DailyUsageForm
                  :readOnly="!canCreate && !canEdit"
                  :usage="resource.expectedDailyUsage"
                />
              </v-row>
              <v-row>
                <FormActions
                  :cancel="handleCancel"
                  :submit="handleSubmit"
                  :destroy="handleDestroy"
                  :canDestroy="canDestroy"
                  :canEdit="canEdit"
                  :canCreate="canCreate"
                  :isValid="isValid"
                  :submitting="submitting"
                />
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Formable from '@/mixins/formable';

export default {
  mixins: [Formable],
  components: {
    DailyUsageForm: () => import('@/components/forms/DailyUsageForm.vue'),
  },
  props: {
    chemicals: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      resourceName: 'ChemicalCost',
    };
  },
};
</script>
